import React from "react";

const { Provider: ReportDataProvider, Consumer: ReportDataConsumer } = React.createContext();
export { ReportDataProvider, ReportDataConsumer };
